export default {
  user:{
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    name: "Nom & Prénoms",
    email: "Email",
    roles: "Rôles",
    emailVerified: "Email vérifié",
    projects: "Projets",
    verified: "Vérifié",
    notVerified: "Non vérifié",
    filter: {
      title: "Filtrer les utilisateurs",
      state: "État de l'utilisateur",
      selectState: "Sélectionnez un état",
      roles: "Rôles",
      apply: "Filtrer",
    },
    edit: {
      title: "Modifier un utilisateur",
      name: "Nom",
      firstname: "Prénom",
      email: "Email",
      roles: "Rôles",
      save: "Modifier",
    },
  }
}
